import { lazyPipe, validateApiResponse, withApiErrorCapture } from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { profileApiPath } from './apiPath';

const GetCuratorUserInfoResponseDataSchema = z
  .object({
    platformCode: z.string(),
    platformMemberUid: z.string(),
    registeredDate: z.string().nullish(),
    snsTitle: z.string().nullish(),
  })
  .describe('GetCuratorUserInfoResponseDataSchema');

const GetCuratorUserInfoResponseSchema = createApiResponseSchema(
  GetCuratorUserInfoResponseDataSchema,
);

type GetCuratorUserInfoResponse = z.infer<typeof GetCuratorUserInfoResponseSchema>;

/**
 * @url https://dev-curator-api.29cm.co.kr/api2/affiliate/swagger-ui/index.html?configUrl=/swagger-ui/api-docs/swagger-config#/Curator/getAuthUserInfo
 */
export const getCuratorUserInfo = withApiErrorCapture(
  lazyPipe(
    () =>
      executeStandardRequest(async () =>
        privateHttpClient.get<GetCuratorUserInfoResponse>(profileApiPath.getCuratorUserInfo),
      ),
    validateApiResponse(GetCuratorUserInfoResponseSchema),
  ),
);
